import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdvancedReorderService } from 'src/app/_services/advanced-reorder.service';
import { DatatableData } from 'src/app/_models/datatable-data';
import { StoresManager } from 'src/app/_global/stores-manager';
import { Locations } from 'src/app/_global/locations';
import { Suppliers } from 'src/app/_global/suppliers';
import { AdvancedReorderRules } from 'src/app/_global/advanced-reorder-rules';
import { LoadingService } from 'src/app/_services/loading.service';
import { AdvancedReorderItem } from '../advanced-reorder-item';
import { AdvancedReorderPage } from '../advanced-reorder-page';

@Component({
  selector: 'app-advanced-reorder-subs',
  templateUrl: './advanced-reorder-subs.component.html',
  styleUrls: ['./advanced-reorder-subs.component.scss']
})
export class AdvancedReorderSubsComponent extends AdvancedReorderPage implements OnInit {
  constructor(
    public advReorderService: AdvancedReorderService,
    public advReorderRules: AdvancedReorderRules,
    private router: Router,
    private route: ActivatedRoute,
    public locations: Locations,
    public suppliers: Suppliers,
    public stores: StoresManager,
    public loadingService: LoadingService) {
      super();
  }

  ngOnInit() {
    this.data.parentKey = this.route.snapshot.params.id;
    this.formGroup = this.fb.group({
      adjustment: [0],
      minusInventory: [false],
      minusStoreInventory: [false],
      minusOverstockedStoreInventory: [false],
      minusPOs: [false],
      outOfStock: [true],
      buyBox: [false],
      supplierId: [null],
    });
    this.formGroup.controls.supplierId.valueChanges.subscribe(supplierId => {
      this.main.data.supplierId = supplierId;
      this.main.supplier = this.suppliers.suppliers.find(s => s.id == supplierId);
      if (this.main.supplier) {
        this.setDayToArrive(this.main, this.main.supplier.defaultBySea ? 'bySea' : 'byAir',
          this.main.supplier.defaultBySea ? this.main.supplier.bySea : this.main.supplier.byAir);
        if (this.main.orderForYears) {
          let totalDays = 0;
          this.main.orderForYears.forEach(monthly => monthly.forEach(month =>
            totalDays += month.days = this.getAvailableDays(this.main, month.date.toISOString())));
          this.main.formGroup?.controls.totalDays.setValue(totalDays);
        }
      }
    });
    this.formGroup.controls.minusInventory.valueChanges.subscribe(value => {
      this.setAllLocations(this, value);
      this.filterChanged();
    });
    this.formGroup.controls.minusStoreInventory.valueChanges.subscribe(value => {
      this.setAllStores(this, value);
      if (!value)
        this.formGroup.controls.minusOverstockedStoreInventory.setValue(false);
      this.filterChanged();
    });
    this.formGroup.controls.minusOverstockedStoreInventory.valueChanges.subscribe(value => {
      this.setAllOverstockedStores(this, value);
      this.filterChanged();
    });
    ['minusPOs', 'outOfStock', 'buyBox'].forEach(ctrl =>
      this.formGroup.controls[ctrl].valueChanges.subscribe(() => this.filterChanged()));
    this.loadingService.loading = true;
    this.suppliers.getAll(() =>
      this.locations.getAll(locations =>
        this.stores.getAll(stores =>
          this.advReorderRules.getAll(rules =>
            this.advReorderService.getAddedReorder().subscribe(res => {
              this.addedReorders = res;
              setTimeout(() => {
                let allLocationsForm = {};
                let allStoresForm = {};
                let allOverstockedStoresForm = {};
                for (let location of locations)
                  allLocationsForm[location.id] = false;
                for (let store of stores) {
                  allStoresForm[store.id] = false;
                  allOverstockedStoresForm[store.id] = false;
                }
                this.locationsFormGroup = this.fb.group(allLocationsForm);
                this.locationsFormGroup.valueChanges.subscribe(() => { this.selectLocation(this) });
                this.storesFormGroup = this.fb.group(allStoresForm);
                this.storesFormGroup.valueChanges.subscribe(() => { this.selectStore(this) });
                this.overstockedStoresFormGroup = this.fb.group(allOverstockedStoresForm);
                this.overstockedStoresFormGroup.valueChanges.subscribe(() => { this.selectOverstockedStore(this) });
                this.loadingService.loading = false;
                this.basedOn = this.basedOn1;
                this.orderFor = this.orderFor1;
                if (history.state.configs) {
                  this.loadConfigs(history.state.configs);
                  this.selectRule(rules.find(r => this.configs ? (this.configs.ruleId ? r.id == this.configs.ruleId : false) : r.isDefault));
                } else {
                  this.selectRule(rules.find(r => this.configs?.ruleId ? r.id == this.configs.ruleId : r.isDefault));
                }
                if (history.state.main) {
                  this.ruleChanged = false;
                  this.main = { ...history.state.main };
                  this.setItemForms(this.main);
                }
                if (history.state.subsData) {
                  history.state.subsData.items.forEach(item => this.setItemForms(item));
                  this.data = history.state.subsData;
                  for (let item of this.data.items)
                    this.refreshOrders(item);   
                  this.allItems = this.data.items;     
                }
                else
                  this.loadData();
              }, 0);
            })
          )
        )
      )
    );
  }

  loadData(data: DatatableData = this.data) {
    this.loadingService.loading = true;
    if (this.ruleChanged || !this.main)
      this.loadMain(data);
    else
      this.loadItems(data);
  }

  loadItems(data: DatatableData = this.data) {
    this.ruleChanged = false;
    this.tagsChanged = false;
    this.applyConfigs();
    if (data.parentKey) {
      this.advReorderService.getSubs(data.parentKey, this.basedOn.selectedDays,
        this.basedOn.hasCustom ? `{${this.basedOn.getSelectedMonths().join(',')}}` : null, this.orderFor.selectedDays,
        this.orderFor.hasCustom ? `{${this.orderFor.getSelectedMonths().join(',')}}` : null, this.formGroup.value.adjustment,
        this.formGroup.value.outOfStock, this.formGroup.value.buyBox, this.minusAllInventory,
        this.locationsFormGroup ? Object.keys(this.locationsFormGroup.value).filter(id => this.locationsFormGroup.value[id] == true).map(id => Number(id)) : [],
        this.minusAllStoresInventory,
        this.storesFormGroup ? Object.keys(this.storesFormGroup.value).filter(id => this.storesFormGroup.value[id] == true).map(id => Number(id)) : [],
        this.minusAllStoresOverstockedInventory,
        this.overstockedStoresFormGroup ? Object.keys(this.overstockedStoresFormGroup.value).filter(id => this.overstockedStoresFormGroup.value[id] == true).map(id => Number(id)) : [],
        this.formGroup.value.minusPOs, !this.applyToAll, this.selectedTags, data.page, data.pageSize, data.sortField,
          data.sort, data.filters).subscribe(result => this.dataLoaded(result));
    }
  }

  loadListings(item: AdvancedReorderItem) {
    if (item.data.listings) {
      if (this.allItems.every(itm => !itm.unsavedChanges || itm == item))
        this.unsavedChanges = false;
      this.router.navigate(["advancedreorder", this.data.parentKey, item.data.productId, 'listings'],
        { state: { subConfigs: this.getItemConfigs(item),
          configs: history.state.configs, main: this.cloneItem(this.main),
          mainsData: history.state.mainsData, subsData: this.cloneData(this.data),
          search: this.searchBox.nativeElement.value } });
    }
  }

  order() {
    const products = this.addedReorders.map(item => ({
      productId: item.productId,
      sku: item.sku,
      details: item.details,
      supplierId: item.supplierId,
      supplier: item.supplier,
      toBuy: item.addedQuantity,
      price: !!item.allPrices && item.allPrices.length > 0 ? (item.allPrices.find(p => p.supplierId == item.supplierId) || item.allPrices[0]).price : undefined
    }));
    localStorage.setItem('advancedReorder', JSON.stringify({ products }));
    let state = { configs: this.configs, main: this.cloneItem(this.main), subsData: this.cloneData(this.data),
      params: [this.data.parentKey, 'subs'], search: this.searchBox.nativeElement.value } as any;
    if (history.state.mainsData)
      state.mainsData = history.state.mainsData;
    this.router.navigate(['/products', 'inventory-reorder'],
      { queryParams: { type: 'advanced' }, state: state });
  }

  goBack() {
    if (history.state.mainsData && !this.settingChanged)
      this.router.navigate(['advancedreorder'], { state: { mainConfigs: history.state.mainConfigs,
        mainsData: history.state.mainsData, search: history.state.search } });
    else
      this.router.navigate(['advancedreorder']);
  }
}